<template>
  <section class="container pb-8 ">
    <div class="row">
      <div class="col-12 col-md-6 col-lg-8 mb-3">
        <div class="btn-group" role="group" aria-label="Basic example">
          <button
            type="button"
            v-bind:class="['btn', CardOrListType === '1' ? 'btn-primary' : 'btn-light']"
            @click="CardOrList('1')"
          >
            <i class="fa fa-th-large mr-2" aria-hidden="true"></i>圖示
          </button>
          <button
            type="button"
            v-bind:class="['btn', CardOrListType === '2' ? 'btn-primary' : 'btn-light']"
            @click="CardOrList('2')"
          >
            <i class="fa fa-list mr-2" aria-hidden="true"></i>清單
          </button>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 mb-3">
        <div class="input-group float-right">
          <input
            type="text"
            class="form-control"
            v-model="Args.keyWord"
            placeholder="課程/課堂名稱查詢"
            aria-label=""
            aria-describedby="basic-addon1"
            @keydown.enter="Search(0)"
          />
          <div class="input-group-prepend">
            <button class="btn btn-outline-secondary" type="button" @click="Search">
              <i class="fa fa-search text-muted" aria-hidden="true"></i>
            </button>
            <button class="btn btn-outline-secondary" type="button" @click="Search(1)">
              清除
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="error-bg mb-3 mb-md-8" v-if="PageInfo.data.length === 0">
      <div>查無上課資料</div>
    </div>

    <ul class="row p-3" v-if="PageInfo.data.length !== 0 && CardOrListType === '1'">
      <li
        v-for="(item, index) in PageInfo.data"
        :key="index"
        class="col-12 col-md-6 col-lg-12 mb-1 mb-lg-6"
      >
        <div class="row py-3 py-lg-6 rounded-lg border-shadow">
          <div class="col-lg-4 position-relative bg-outer mb-3 mb-lg-0">
            <div
              class="bg-image rounded-lg"
              :style="{
                paddingBottom: '50%',
                backgroundImage: 'url(' + item.mainImagePath + ')',
              }"
            ></div>
          </div>
          <div class="col-lg-6 d-flex flex-column align-self-stretch">
            <h5 class="text-ellipsis mb-1 mb-md-3">{{ item.courseName }}</h5>
            <div class="cs-table" data-style="7">
              <dl>
                <dt><i class="fa fa-calendar mr-2" aria-hidden="true"></i>觀看期限：</dt>
                <dd>
                  {{ item.courseViewStartDate | toTaipei | moment('YYYY-MM-DD') }} -
                  {{ item.courseViewEndDate | toTaipei | moment('YYYY-MM-DD') }}
                </dd>
              </dl>
              <dl v-if="item.limitViewStartDate && item.limitViewEndDate">
                <dt><i class="fa fa-clock-o mr-2" aria-hidden="true"></i>觀看天數：</dt>
                <dd>
                  <span class="text-danger">
                    {{ item.limitViewStartDate | toTaipei | moment('YYYY-MM-DD') }} -
                    {{ item.limitViewEndDate | toTaipei | moment('YYYY-MM-DD') }}
                  </span>
                </dd>
              </dl>
              <dl>
                <dt><i class="fa fa-book mr-2" aria-hidden="true"></i>總堂數：</dt>
                <dd>
                  <span class="mr-1">{{ item.courseCount }}</span
                  >堂
                </dd>
              </dl>
              <dl>
                <dt><i class="fa fa-tag mr-2" aria-hidden="true"></i>類型：</dt>
                <dd>
                  <span class="mr-1">{{ item.courseTypeName }}</span>
                </dd>
              </dl>
            </div>
          </div>
          <div class="col-lg-2 align-self-end">
            <router-link
              class="btn btn-primary w-100"
              :to="`/learnings/${item.courseId}`"
              v-if="item.hasLook"
            >
              上課去
            </router-link>
            <a href="" class="btn btn-secondary w-100" @click.prevent v-else> 尚未開放 </a>
          </div>
        </div>
      </li>
    </ul>

    <ul class="row p-3" v-else-if="PageInfo.data.length !== 0 && CardOrListType === '2'">
      <li
        v-for="(item, index) in PageInfo.data"
        :key="index"
        class="col-12 col-md-6 col-lg-12 mb-1 mb-lg-3"
      >
        <div class="row py-2 py-lg-4 rounded-lg border-shadow">
          <div class="col-lg-5 mb-2 mb-lg-0 ">
            <h5 class="text-ellipsis mb-1 mb-md-3">{{ item.courseName }}</h5>
          </div>
          <div class="col-lg-5 d-flex flex-column align-self-stretch">
            <div class="cs-table" data-style="7">
              <dl>
                <dt><i class="fa fa-calendar mr-2" aria-hidden="true"></i>觀看期限：</dt>
                <dd>
                  {{ item.courseViewStartDate | toTaipei | moment('YYYY-MM-DD') }} -
                  {{ item.courseViewEndDate | toTaipei | moment('YYYY-MM-DD') }}
                </dd>
              </dl>
              <dl v-if="item.limitViewStartDate && item.limitViewEndDate">
                <dt><i class="fa fa-clock-o mr-2" aria-hidden="true"></i>觀看天數：</dt>
                <dd>
                  <span class="text-danger">
                    {{ item.limitViewStartDate | toTaipei | moment('YYYY-MM-DD') }} -
                    {{ item.limitViewEndDate | toTaipei | moment('YYYY-MM-DD') }}
                  </span>
                </dd>
              </dl>
            </div>
          </div>
          <div class="col-lg-2 align-self-end">
            <router-link
              class="btn btn-primary w-100"
              :to="`/learnings/${item.courseId}`"
              v-if="item.hasLook"
            >
              上課去
            </router-link>
            <a href="" class="btn btn-secondary w-100" @click.prevent v-else> 尚未開放 </a>
          </div>
        </div>
      </li>
    </ul>

    <!-- 分頁 -->
    <Pagination
      @GetList="GetList()"
      :page.sync="Pagination.pageIndex"
      :page-row="Pagination.pageSize"
      :total-count="PageInfo.count"
    />
  </section>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import { GetGotoClass } from '@/api/OrderApi';

export default {
  components: {
    Pagination,
  },
  data() {
    // 建立你的初始化 model data
    return {
      Args: { keyWord: '' },
      Pagination: {
        // 有分頁要有此model data
        pageIndex: 1, // 預設從第幾頁開始
        pageSize: 10, // 預設每頁幾筆
        data: {
          keyWord: '',
        },
      },
      PageInfo: {
        count: 0, // api給的總筆數
        data: [],
      },
      CardOrListType: '1', // 設定在哪種清單模式 1圖示(好看) 2清單(醜醜)
    };
  },
  // 當有設定keep的時候，返回到此頁面會執行這個，不會執行created()，所以這邊就不用放created()
  async activated() {
    const myStorage = window.localStorage;
    this.CardOrListType = myStorage.getItem('LearningsListType') !== null
      ? myStorage.getItem('LearningsListType')
      : '1';
    if (!this.$route.meta.isBack) {
      // 不是從指定頁面返回的話，進行初始化設定
      this.Args = { keyWord: '' };
      this.Pagination = {
        pageIndex: 1, // 預設從第幾頁開始
        pageSize: 10, // 預設每頁幾筆
        data: {
          keyWord: '',
        },
      };
      this.PageInfo = {
        count: 0, // api給的總筆數
        data: [],
      };
    }
    // 然後再針對頁面進行初始化資料存取
    this.GetList();
  },
  methods: {
    Search(isClear = 0) {
      this.Pagination = {
        pageIndex: 1, // 預設從第幾頁開始
        pageSize: 10, // 預設每頁幾筆
        data: {
          keyWord: '',
        },
      };
      if (isClear === 0) this.Pagination.data = { ...this.Args };
      if (isClear === 1) this.Args = { keyWord: '' };
      this.GetList();
    },
    GetList() {
      this.Pagination.data = { ...this.Args };
      GetGotoClass(this.Pagination).then((response) => {
        if (response.data.statusCode === 0) {
          this.PageInfo.count = response.data.count;
          this.PageInfo.data = response.data.data;
          if (this.Pagination.pageIndex !== 1 && this.PageInfo.data.length === 0) {
            this.Pagination.pageIndex = 1;
            this.GetList();
          }
        }
      });
    },
    CardOrList(type) {
      this.CardOrListType = type;
      const myStorage = window.localStorage;
      myStorage.setItem('LearningsListType', type);
    },
  },
};
</script>

<style></style>
